import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaRE/step3';
import { CTRL_499 } from '../../../validators/499/ctrl499';
import { TypeDescMarche } from '../models/TypeDescMarche';
import { MapaREControlNames } from '../services/mapaREControleNames';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
@Component({
  selector: 'app-type-desc-marche',
  templateUrl: './type-desc-marche.component.html'
})
export class TypeDescMarcheComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeDescMarche';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() description: TypeDescMarche;
  estCbChecked: boolean;

  public step3 = new Step3();
  public rg1 = '_STEP_ID_3_' + CTRL_499.id + '_1';
  public rg2 = CTRL_268.id + '_2';
  public rg3 = CTRL_268.id + '_3';
  public rg4 = CTRL_268.id + '_4';

  constructor(private avisDataTransferService: AvisDataTransferService) { }

  public ngOnInit() {
    this.parentForm.addControl(this.rg1, new FormControl({ rgCtrls: MapaREControlNames.getCtrl_499Names_json() }));
    this.isChecked();
  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte(){
    const controlName = this.getUid() + '_SepAtt_lieuExecutionCB';
    const control = this.parentForm.get(controlName);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.isChecked()
      });
    }
  }

  isChecked() {
    this.estCbChecked = this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'] ?
                        this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'].value :
                        this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.rectificatifFromMAPA.description.isLieuExecutionLivraison;
    if (this.estCbChecked) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_268_3Names_json() }));
    } else {
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_268_1Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_268_2Names_json() }));
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

}

